import { z } from "zod"

/**
 * Onboarding types that define different customer acquisition flows
 */
const subscriptionType = {
    /** Replaces Old Telesales Channel utils
     * Is for customers using the navigator/comparison tool (FIELD_SALES / PRICE_COMPARISON / WORKPLACE_POPUP ) */
    NAVIGATOR: "NAVIGATOR",
    /** Direct subscription flow for customers signing up for a new contract */
    DEFAULT: "DEFAULT",
    /** Direct subscription flow for existing customers signing up for a new gas contract */
    CROSS_SALE: "CROSS_SALE",
    /** Customer received a quote via email and is proceeding with the onboarding process */
    EMAIL_QUOTE: "EMAIL_QUOTE",
    /** Customer was contacted by telesales team and is completing the signup process */
    CHECKOUT_PAGES: "CHECKOUT_PAGES",
    /** Customer is moving out and subscribes to a new offer */
    MOVE_OUT: "MOVE_OUT",
} as const

export const SubscriptionTypeSchema = z.enum(subscriptionType)
export type SubscriptionType = z.infer<typeof SubscriptionTypeSchema>
